import { Label, Text } from '@viapeople/components'

interface EnpsSurveyCardProps {
	surveyName: string
	questionText: string
	launchedAt: Date | null
	onClick: () => void
}

export function EnpsSurveyCard({ surveyName, questionText, launchedAt, onClick }: EnpsSurveyCardProps) {
	const formatDate = (date: Date | null) => {
		if (!date) return '-'
		return new Date(date).toLocaleDateString('en-US', {
			year: 'numeric',
			month: 'short',
			day: 'numeric',
		})
	}

	return (
		<button
			type='button'
			onClick={onClick}
			className='w-full border border-neutral-200 rounded-lg px-6 py-4 hover:bg-neutral-50 transition-colors'>
			<div className='flex items-center justify-between'>
				<div className='flex items-center space-x-3'>
					<Text variant='h6' weight='semibold' className='text-neutral-900'>
						NPS Survey
					</Text>
				</div>

				<div className='flex items-center space-x-8'>
					{/* Survey Name */}
					<div className='text-right'>
						<Text variant='xsmall' weight='regular' className='text-neutral-500'>
							Survey
						</Text>
						<Text variant='small' weight='semibold' className='text-neutral-900'>
							{surveyName}
						</Text>
					</div>

					{/* Question Preview */}
					<div className='text-right max-w-xs'>
						<Text variant='xsmall' weight='regular' className='text-neutral-500'>
							Question
						</Text>
						<Text variant='small' weight='semibold' className='text-neutral-900 truncate'>
							{questionText.length > 40 ? `${questionText.substring(0, 40)}...` : questionText}
						</Text>
					</div>

					{/* Launched Date */}
					<div className='text-right'>
						<Text variant='xsmall' weight='regular' className='text-neutral-500'>
							Sent
						</Text>
						<Text variant='small' weight='semibold' className='text-neutral-900'>
							{formatDate(launchedAt)}
						</Text>
					</div>

					{/* Status */}
					<div>
						<Label color='yellow'>Pending</Label>
					</div>
				</div>
			</div>
		</button>
	)
}
